import { Icon } from '@iconify/react';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'left',
  padding: theme.spacing(2, 2),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));


// ----------------------------------------------------------------------


export default function APPlatestaccstatus(props) {
  return (
    <RootStyle>
      <Typography variant="h5">
      {props.title} <Icon icon="fa-solid:wind" width={24} height={24} />
      </Typography>
      <Typography variant="h5">
      {props.state}
      </Typography>
    </RootStyle>
  );
}
